import { tap, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { WaitingService } from './waiting.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  constructor(private waiting: WaitingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.waiting.show();
    
    return next.handle(request)
      .pipe(tap(), finalize(() => {
        this.waiting.hide();
      }));
  }
}
